import { Controller } from 'stimulus';
import loadCss from '../helpers/loadCss';
import throttle from '../helpers/throttle';
import universalTracking from '../tracking/universalTracking';

let Plyr = null;

const VIDEO_THRESHOLDS = [25, 50, 75, 100];

class Video extends Controller {
  connect() {
    this.player = null;

    this.thresholds = VIDEO_THRESHOLDS.slice();

    this.provider = this.elementTarget.getAttribute('data-plyr-provider');
    this.embedId = this.elementTarget.getAttribute('data-plyr-embed-id');

    this.throttledTimeUpdate = throttle(this.onTimeUpdate.bind(this), 1000);

    Video.loadVideoJs().then((module) => {
      Video.loadVideoCSS().then(() => {
        Plyr = module.default;

        if (this.data.get('lazy') === null) {
          this.setupPlayer();
        }
      });
    });
  }

  onPlay() {
    this.setupPlayer();

    if (this.hasPosterTarget) {
      this.posterTarget.style.opacity = 0;
      this.posterTarget.style.visibility = 'hidden';
    }

    this.player.on('ready', () => {
      this.player.play();
    });
  }

  setupPlayer() {
    this.player = new Plyr(this.elementTarget);

    this.eventListeners();
  }

  eventListeners() {
    this.player.on('timeupdate', this.throttledTimeUpdate);
  }

  onTimeUpdate(event) {
    const { currentTime, duration } = event.detail.plyr;
    const currentThreshold = (currentTime / duration) * 100;

    this.thresholds.forEach((threshold) => {
      const index = this.thresholds.indexOf(threshold);

      if (currentThreshold >= threshold) {
        this.thresholds.splice(index, 1);

        const label = `${this.provider}:${this.embedId}`;

        universalTracking.event('Video threshold', threshold, label);
      }
    });
  }

  static loadVideoJs() {
    return import(/* webpackChunkName: "video" */ 'plyr');
  }

  static loadVideoCSS() {
    return loadCss('/front_assets/css/plyr.css');
  }
}

Video.targets = [
  'container',
  'element',
  'poster',
];

export default Video;
